import { TableColumnHeader } from "@/components/shared/table/Table";
import { Button } from "@/components/ui/button";
import { VacationDays } from "@/graphql/__generated__/graphql";
import { formatDateLocale, getProvinceNameByCode } from "@/utils/helpers";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { TrashIcon } from "lucide-react";
import { IntlShape } from "react-intl";

export const getColumnsVacationDays = (
  intl: IntlShape,
  t: TFunction,
  handleRemoveVacationDays: (_vacationDays: VacationDays) => void,
  isConfigAdmin: boolean,
): ColumnDef<VacationDays>[] => [
  {
    id: "activeFrom",
    accessorKey: "activeFrom",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationdays.columns.activefrom")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const activeFrom = new Date(row.getValue("activeFrom"));
      return <div>{formatDateLocale(intl, activeFrom)}</div>;
    }
  },
  {
    accessorKey: "province",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationdays.columns.province")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const provinceCode = row.getValue("province") as string;
      return <div>{getProvinceNameByCode(provinceCode, true)}</div>;
    },
  },
  {
    id: "days",
    accessorKey: "days",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationdays.columns.days")}
        column={column}
        align="end"
      />
    ),
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("days"));
      return <div className="text-right font-medium">{value} {t("tables:vacationdays.days")}</div>;
    }
  },
  {
    id: "lengthOfEmployment",
    accessorKey: "lengthOfEmployment",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationdays.columns.lengthofemployment")}
        column={column}
        align="end"
      />
    ),
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("lengthOfEmployment"));
      return <div className="text-right font-medium">{value} {t("tables:vacationdays.years")}</div>;
    }
  },
  ...(isConfigAdmin
    ? [
      {
        accessorKey: "actions",
        size: 40,
        header: () => <div className="flex justify-end"></div>,
        cell: ({ row }) => (
          <div className="flex gap-2 justify-end">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleRemoveVacationDays(row.original)}
            >
              <TrashIcon className="w-4 h-4 text-red-500" />
            </Button>
          </div>
        ),
      },
    ]
    : []),
];
